import { FeatureKey } from 'common/constants/permission'
import { POND_TAB_ORDER, PondTab } from 'modules/pond/constants'

/**
 * First tab the user is allowed to see, in display order. `allowedTabs` comes
 * from useAllowPondTabs(), whose order follows the permission payload.
 */
export const getFirstAllowedPondTab = (allowedTabs: PondTab[]): PondTab | undefined =>
  POND_TAB_ORDER.find((tab) => allowedTabs.includes(tab)) ?? allowedTabs[0]

export const convertFeatureKeyToPondTab = (key: FeatureKey): PondTab => {
  switch (key) {
    case FeatureKey.Food:
      return PondTab.Food
    case FeatureKey.Growth:
      return PondTab.Growth
    case FeatureKey.Partial:
      return PondTab.Partial
    case FeatureKey.WaterQuality:
    case FeatureKey.WaterMineral:
    case FeatureKey.WaterVibrio:
      return PondTab.Water
    case FeatureKey.Death:
      return PondTab.DeadShrimp
    case FeatureKey.Medicine:
      return PondTab.Medicine
    case FeatureKey.Cost:
      return PondTab.Cost
    case FeatureKey.Sales:
      return PondTab.Sales
    case FeatureKey.Cycle:
      return PondTab.Setting
    case FeatureKey.Dashboard:
      return PondTab.Summary
    case FeatureKey.DailyRecord:
    default:
      return PondTab.Dashboard
  }
}
